import { Flex } from "@chakra-ui/react";
import { ReactNode, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import SideBar from "../../../components/SideBar";
import SecondarySidebar from "../../../components/v2/SecondarySidebar";
import { selectAccount } from "../../account/accountSlice";
import UserList from "../users/UserList";
import EmailSettings from "./EmailSettings";
import SsoConfiguration from "./SsoConfiguration";

const SIDEBAR_ITEMS = ["Email Settings", "Users"];
const SSO_OPTION = "Single Sign-on";
const settingTabs: Record<(typeof SIDEBAR_ITEMS)[number], ReactNode> = {
  [SIDEBAR_ITEMS[0]]: <EmailSettings />,
  [SIDEBAR_ITEMS[1]]: <UserList />,
  [SSO_OPTION]: <SsoConfiguration />,
};

const SSO_ALLOWED_ORG = 114;

export default function Settings() {
  const [selectedOption, setSelectedOption] = useState(0);
  const {
    user: { organisation_id },
  } = useSelector(selectAccount);

  const filteredSidebarItems = useMemo(() => {
    const options = [...SIDEBAR_ITEMS];
    // Hotfix for sc-10539 (To hide sso for all other orgs except SSO_ALLOWED_ORG)
    organisation_id === SSO_ALLOWED_ORG && options.splice(1, 0, SSO_OPTION);
    return options;
  }, [organisation_id]);

  return (
    <Flex>
      <SecondarySidebar heading="Settings">
        <SideBar
          options={filteredSidebarItems}
          selected={selectedOption}
          select={setSelectedOption}
        />
      </SecondarySidebar>
      {settingTabs[filteredSidebarItems[selectedOption]]}
    </Flex>
  );
}
